export class TestingModel {
    showContentKey: boolean = false;
    constructor() {}
}

